import React, { Component, Fragment } from 'react'
import TopNavigation from '../components/TopNavigation/header';
import PageTop from '../components/PageTop/PageTop';
import Footer from '../components/Footer/Footer';
import CourseDetails from '../components/CourseDetails/CourseDetails';


export class CourseDetailsPage extends Component {

  componentDidMount(){
    window.scroll(0,0);
  }



  render() {
    return (
     <Fragment>
        <TopNavigation></TopNavigation>
        <PageTop pageTitle="Up Coming Event Details"></PageTop>
        <CourseDetails> </CourseDetails>
        <Footer></Footer>
        
     </Fragment>
     
    )
  }
}

export default CourseDetailsPage
